import { Outlet } from "react-router-dom";

const SocialMedia = () => {
    return <Outlet />;
};

export default SocialMedia;
